export default __webpack_public_path__ + "/dist/images/avatar-logo.9e4076ee8a56f2603d3a14ca7c8d93fc.jpg";